import { render, staticRenderFns } from "./ShareDropdown.vue?vue&type=template&id=22dea5b3"
import script from "./ShareDropdown.vue?vue&type=script&lang=js"
export * from "./ShareDropdown.vue?vue&type=script&lang=js"
import style0 from "./ShareDropdown.vue?vue&type=style&index=0&id=22dea5b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports